import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ProjectActionTypes } from '../../redux/project/project.types';
import Header from '../../components/home/header/header.component';
import GreenLine from '../../components/greenline/greenline.component';
import FooterNew from '../../components/footernew/footernew.component';
import { removeFirstChar } from '../../utils/utils';
import { language as MAINLANG } from '../../utils/lang';
import './mentorluk.page.styles.scss';

const MentorlukPage = () => {
  const xprops = useSelector(state => state);
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);
  const setParent = (value) => dispatch({type: ProjectActionTypes.SET_PARENT, value: value });  
 
  if(!mounted){
    if (xprops.language === undefined){
      setParent(removeFirstChar(MAINLANG.TR.routes.mentoring));  
    }else{
      setParent(removeFirstChar(xprops.language.routes.mentoring));  
    }
  }  

  useEffect(() =>{
    setMounted(true);
    window.scrollTo(0,0);
  },[]);  

    return(
      <React.Fragment>
        <div className="homeWrapper">
          <Header />
          <div className="newSectionWrapper">
          <GreenLine classx="spacebottom"/>
          <div className="newContentLayerWrapper">
            <div className="subContentSectionWrapper">
              <h1 className="subContentTitle">{xprops.project.language.keywords.mentorship}</h1>
              <img className="imgMentorluk" src="/assets/images/mentorluk.jpg" alt={xprops.project.language.keywords.mentorship} />
              <p className="subContentParagraph2">
                {
                  xprops.project.language.short === "TR" ?
                  <React.Fragment>
                                  “Kendinizi yetersiz hissettiğiniz, ifade etmekte zorlandığınız veya ifade etmekten kaçındığınız durumlarla karşılaşıyor musunuz? Ast-üst ilişki yönetimi, ücret görüşmeleri, terfi konuşmalarını yönetmek veya iş-yaşam dengenizi olumlu yönde değiştirecek farklı taleplerinizi dile getirmek için desteğe mi ihtiyacınız var? İster özel sektörde, ister akademide, ister sivil toplumda olsun, iş ortamınız, çalışma arkadaşlarınız sizi strese sokuyor mu?<br/>
                    Eğer bu sorular hayatınızı ve kariyerinizi olumsuz etkiliyorsa, Sensiz Olmaz Sessiz Olmaz’ın veri tabanında yer alan üye kadın uzmanlar için sunduğu koçluk çalışmasından yararlanabilirsiniz.”<br/><br/>

                    Sensiz Olmaz Sessiz Olmaz platformu medya eğitimlerinin yanı sıra 2022’de kadınları iş hayatı kariyerlerinde güçlendirme amacı ile koçluk çalışması başlattı. Çalışma ile belirli sayıda kadın uzmana iş hayatlarında karşılaştıkları herhangi bir konuda destek verilmesi hedeflendi. Terfi görüşmesi yapma, hakkını arama, sunum yaparken rahat hissetme ve benzeri konularda çalışma yapmak isteyen 11 kadın uzman çalışmada yer aldı. Katılımcılar Sensiz Olmaz Sessiz Olmaz veri tabanına üye uzman kadınlar arasından seçildi.<br/> 
                    Katılımcılar kişiye ve kendi seçtikleri konuya özel birebir yürütülen bir koçluk çalışmasına dahil oldular. Koçluk çalışması Profesyonel Koç Rana Beri, MCC ile yapılan iki seanstan oluştu.<br/><br/> 
                  </React.Fragment>
                  :
                  <React.Fragment>
                    Do you ever feel incompetent, struggle to express yourself, or avoid expressing your thoughts in certain situations? Do you need support in managing superior-subordinate relationships, salary negotiations, promotion discussions, or voicing requests that could positively impact your work-life balance? Whether you work in the private sector, academia, or civil society, do your work environment or colleagues cause you stress?<br/><br/>
                    If these challenges negatively affect your life and career, you can benefit from the coaching program offered by {xprops.project.language.metas.title} for women specialists.<br/><br/>                    
                    In addition to media training, {xprops.project.language.metas.title} launched a coaching initiative in 2022 to empower women in their professional careers. The program aimed to support a selected group of women experts in overcoming workplace challenges. Between 2022 and 2024, 17 women experts participated in the program, focusing on topics such as handling promotion negotiations, advocating for their rights, and feeling confident while presenting.<br/><br/>                    
                    Upon application, participants were selected from the expert women registered in the {xprops.project.language.metas.title} database. . Each participant received personalized, one-on-one coaching tailored to their chosen topic. The coaching program consisted of two sessions led by <b>Professional Coach Rana Beri, MCC.</b><br/><br/>                    
                  </React.Fragment>
                }
              </p>
            </div>
          </div>
        </div>
        </div>
        <FooterNew />
      </React.Fragment>
    );
};

export default MentorlukPage;